import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { SocialValidation } from './components/SocialValidation';
import { TestimonialsSection } from './components/TestimonialsSection';
import { CTASection } from './components/CTASection';
import { FAQSection } from './components/FAQSection';
export function App() {
  return <div className="min-h-screen bg-surface-deepest text-white font-body selection:bg-gold/30 selection:text-gold-light" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <SocialValidation data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <CTASection data-id="element-8" />
        <FAQSection data-id="element-9" />
      </main>
    </div>;
}